import { Props } from './Layout'
import { NotificationType, NftType } from '@/src/graphql/generated/types'

export const useProps = (): Props => {
  return {
    nftType: [NftType.ArcadeMachine, NftType.ArcadePart],
    notificationType: NotificationType.Information,
  }
}
